import React, { useContext } from "react";

import { Button } from "reactstrap";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
//import { UdataContext } from "../components/ReactTable/AppContext";
import { Link, NavLink } from "react-router-dom";
import { logout, keepInfHome } from "../store/actions/userAction";
import { eventBus } from "../services/eventBusService";
import { Modal7Profil } from "./Modal7profil";

const Navbar = () => {
  const dispatch = useDispatch();
  const [openFlagProfil, setOpenFlagProfil] = useState(false);
  const loggedInUser = useSelector((state) => state.userReducer.loggedInUser);
  const [urlPaye, setUrlPaye] = useState("");

  async function valShab2() {
    const rep3 = await keepInfHome();
    setUrlPaye(rep3[1]);
  }
  useEffect(() => {
    valShab2();
  }, []);
  useEffect(() => {
    const unsubscribe = eventBus.on("editing", () => {
      setOpenFlagProfil(false);
    });

    return unsubscribe;
  }, []);

  const dologout = async (ev) => {
    ev.preventDefault();
    await dispatch(logout());
    window.location.replace("/");
  };

  const doModifProfil = (ev) => {
    ev.preventDefault();
    setOpenFlagProfil(true);
  };

  return (
    <div>
      <nav>
        {openFlagProfil && (
          <Modal7Profil
            isOpen={openFlagProfil}
            toggle={() => setOpenFlagProfil(false)}
          />
        )}
        <div className="nav-container">
          <NavLink exact to="/">
            <div className="navlogo-container">
              <img
                id="logobetyossef"
                src={process.env.PUBLIC_URL + "/assets/bet_yossef_haim.png"}
                alt="icon"
              />

              <h1>BET YOSSEF HAIM </h1>
            </div>
          </NavLink>

          <a target="_blank" href={urlPaye}>
            <Button
              className=" btn-simple animation-on-hover"
              color="info"
              variant="contained"
              onClick={() => {
                " ";
              }}
            >
              <i class=" fab fa-paybox"></i> Payer / faire un don
            </Button>
          </a>
          {loggedInUser ? (
            <div className="nav-user">
              <h3 className="nav-user1">Bienvenue {loggedInUser.firstName} </h3>
              <button className="btn" onClick={doModifProfil}>
                modifier votre profil
              </button>

              <button className="btn" color="success" onClick={dologout}>
                vous deconnecter ?
              </button>
            </div>
          ) : (
            <div className="nav-user">
              <div>
                <NavLink exact to="/login">
                  <button className="btn" color="success">
                    vous connecter ?
                  </button>
                  {/*<h3 className="nav-user1"> connectez-vous...</h3>*/}
                </NavLink>
              </div>
              {/* <div>
              <NavLink exact to="/signup">
                <h4> inscrivez-vous...</h4>
              </NavLink>
           </div> */}
            </div>
          )}
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
